import { EmoticonTongueIcon } from './EmoticonTongueIcon';

/**
 * author: Austin Andrews
 * id 57288378-59EE-4705-ACD5-3B424ACA70C1
 * name emoticon-tongue
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-tongue.svg
 * tags
 * - Emoji 
 */
export const EmojiTongueIcon = EmoticonTongueIcon;
export default EmojiTongueIcon